import { Component } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-dashboard-skeleton',
  templateUrl: './dashboard-skeleton.component.html',
  styleUrls: ['./dashboard-skeleton.component.css'],
  imports: [SkeletonComponent],
})
export class DashboardSkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5];
}
